<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            Recognized in over 20+ countries, let us help you become educated.
                            <br>
                            <span class="uk-text-small uk-text-muted">
                  Late applications may be considered but will attract late fees.
                </span>
                        </p>
                    </div>
                </div>

                <div class="uk-padding  uk-margin-remove-top">
                    <h1 class="uk-heading-line uk-text-center specHeading"><span>International Students</span></h1>
                    <div class="uk-container uk-container-small">


                        <div class="uk-child-width-1-1@m" uk-grid>
                            <div class=" uk-align-center">
                                <img src="../assets/international1.png" alt="">
                            </div>
                            <div class="">
                                <p>
                                    Northern Caribbean University has an international student body with current representation from twenty-nine countries.
                                    It is a government requirement that all prospective students obtain a student visa within the specific time given upon arrival.
                                    Each student must get this extension of stay before completing their first semester.
                                    This process is handled by the Department of International Student Services, which keeps a record of all international
                                    students currently enrolled in the institution. Consequently, all freshmen are expected to visit the Office of International Student
                                    Services within the first week of their arrival in order to submit documents and obtain relevant information.
                                </p>
                                <p >
                                    Students who are of Jamaican parentage may receive a naturalized status after submitting the relevant documents and
                                    following the process outlined by the Passport Immigration and Citizenship Agency. International students must have valid
                                    passports, as well as valid open one-year tickets to their home countries. No visa is required for Commonwealth students.
                                </p>
                                <p>
                                    Students are not allowed entry into the country for the purpose of study without the following:
                                </p>

                                <ul class="uk-list uk-list-bullet">
                                    <li>An acceptance letter from the university</li>
                                    <li>A certificate of good health</li>
                                    <li>A sound financial plan</li>
                                    <li>A valid passport for at least six months after entry</li>
                                    <li>A valid open return ticket to country of origin or a deposit as determined by the Financial Office</li>
                                </ul>
                                <p>
                                    International students should also note that the department of Student Finance requires all students from within the
                                    CARICOM states and the Americas to make a security deposit of US$100.00 which is refundable.
                                    (The university reserves the right to adjust these fees at any time.)
                                </p>
                                <p class="uk-text-muted ">
                                    Visit The Passport, Immigration and Citizenship Agency to get the necessary forms for full immigration processing.
                                    These can also be completed after landing in Jamaica.
                                    The Alien Registration Card will be given to the non-commonwealth students after checking in with the International Student Services department here on campus.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-padding uk-background-muted">
                    <div class="uk-container uk-container-small uk-padding-small">
                        <div uk-grid>

                            <div class="uk-width-1-1">
                                <h3 class="uk-heading-bullet uk-text-muted">Incomplete Applications</h3>
                                <p class="uk-text-small uk-text-muted">
                                    Applicants are reminded that if they were given provisional acceptance and have not yet fulfilled the requirements for acceptance into their programmes,
                                    which include meeting the standard for matriculation, be interviewed by their departments and submission of all outstanding documents, they will not be
                                    given a formal acceptance letter at the New Students’ Meeting.

                                    <br><br>
                                    If you have any questions concerning your admissions process, please feel free to call us at the office at:
                                    <br><br>
                                    Phone: 1-876-963-7250-7
                                    <br><br>
                                    For more information contact admissions@ncu.edu.jm
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    </transition>
</template>

<script>
    export default {
        name: "InternationStudents",
        mounted(){
            window.scrollTo(0, 0);
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU International Students Admission Requirements',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'International Students admission requirements at Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>

</style>
